import type { ModelInterface } from '@nts/std/interfaces';
import { ClassConstructor } from '@nts/std/serialization';
import { NTSReflection } from '@nts/std/utility';
import { cloneDeep } from 'lodash-es';

const META_DATA_IDENTIFICATION_KEY = 'CustomExternalViewModelKey';

export interface CustomExternalViewModelDecoratorInterface {
    modelType: ClassConstructor<ModelInterface>;
    viewModelType: ClassConstructor<any>;
}

export function CustomExternalViewModelDecorator(externalViewModelInfo: CustomExternalViewModelDecoratorInterface) {
    return (target: any, propertyKey: any) => {
        Reflect.defineMetadata(META_DATA_IDENTIFICATION_KEY, externalViewModelInfo, target, propertyKey);
    };
}

export class CustomExternalViewModelInspector {
    static isApplied(subject: any, propertyName: string): boolean {
        return NTSReflection.hasPropertyMetadata(
            META_DATA_IDENTIFICATION_KEY, subject, propertyName);
    }

    static getValue(subject: any, propertyName: string): CustomExternalViewModelDecoratorInterface {
        return cloneDeep(NTSReflection.getPropertyMetadata(
            META_DATA_IDENTIFICATION_KEY, subject, propertyName));
    }
}
